// JS for Posts Block - Category Filtering
document.addEventListener('DOMContentLoaded', function () {
  const categoryFilters = document.querySelectorAll('.category-filter');

  categoryFilters.forEach((filter) => {
    filter.addEventListener('change', function () {
      const blockId = this.getAttribute('data-block-id');
      const categoryId = this.value;
      const postsBlock = document.getElementById(blockId);

      if (!postsBlock) return;

      const postsContent = postsBlock.querySelector('.posts-content');
      const postsView = postsBlock.getAttribute('data-posts-view');
      const postsPerPage = postsBlock.getAttribute('data-posts-per-page');
      const postsOffset = postsBlock.getAttribute('data-posts-offset');

      // Show loading state
      postsContent.style.opacity = '0.5';

      // Prepare AJAX data
      const formData = new FormData();
      formData.append('action', 'filter_posts_by_category');
      formData.append('category_id', categoryId);
      formData.append('posts_view', postsView);
      formData.append('posts_per_page', postsPerPage);
      formData.append('posts_offset', postsOffset);
      formData.append('nonce', ajax_object.nonce);

      // Make AJAX request
      fetch(ajax_object.ajax_url, {
        method: 'POST',
        body: formData,
      })
        .then((response) => response.text())
        .then((html) => {
          postsContent.innerHTML = html;
          postsContent.style.opacity = '1';
        })
        .catch((error) => {
          console.error('Error filtering posts:', error);
          postsContent.style.opacity = '1';
        });
    });
  });
});
